/* eslint-disable @typescript-eslint/no-unused-expressions */
import { energyApi } from "utilities/Axios";

export const getBubblesMeta = () => {
  return energyApi.get(`/UnityData/GetUnityBubbleMeta`);
};

export const getBubblesData = () => {
  return energyApi.get(`/UnityData/GetUnityBubbleData`);
  // return api.get("/Unity/GetUnityBubbleData?dateTime=2023-10-02T22%3A46%3A00.000");
};

export const updateBubblePosition = (data: any) => {
  return energyApi.post(`/Unity/UpdateBubbleCordinates`, data);
};

export const getNotes = () => {
  return energyApi.get(`/UnityData/GetUnityNoteMeta`);
};

export const getEquipment = (id: any) => {
  return energyApi.get(`/UnityData/GetEquipment?id=${id}`);
};

export const getAllEquipmentsMeta = () => {
  return energyApi.get(`/Unity/GetAllEquipmentMeta`);
};

export const getUnit = (id: any) => {
  return energyApi.get(`/UnityData/GetUnit?id=${id}`);
};

export const getWidget = (id: number) => {
  return energyApi.get(`/Unity/GetUnityWidget` + `?id=${id}`);
};

export const createWidget = (data: any) => {
  return energyApi.post(`/Unity/CreateUnityWidget`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const deleteWidget = (props: any) => {
  const id =
    props !== null && typeof props === "object" && "id" in props
      ? (props as any).id
      : props;

  return energyApi.post(`/Unity/DeleteUnityWidget?id=${id}`);
};

export const updateWidget = (data: any) => {
  return energyApi.post(`/Unity/UpdateUnityWidget`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateWidgetPosition = (data: any) => {
  return energyApi.post(`/Unity/UpdateUnityWidgetCordinates`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getAllWidgets = () => {
  return energyApi.get(`/Unity/GetUnityWidgetList`);
};

export const getWidgetsMeta = () => {
  return energyApi.get(`/UnityData/GetUnityWidgetMeta`);
};

export const getWidgetsData = () => {
  return energyApi.get(`/UnityData/GetUnityWidgetData`);
};


export const getNote = (id: any) => {
  return energyApi.get(`Unity/GetNote?id=${id}`);
};

export const getBubble = (id: any) => {
  return energyApi.get(`Unity/GetBubble?id=${id}`);
};

export const downloadFile = (id: any) => {
  return energyApi.get(`/Unity/getFile` + `?id=${id}`);
};

// Notes

export const createNote = (data: any) => {
  return energyApi.post(`/Unity/CreateNote`, data);
};

export const updateNote = (data: any) => {
  return energyApi.post(`/Unity/UpdateNote`, data);
};

export const updateNotesCoordinates = (data: any) => {
  return energyApi.post(`/Unity/UpdateNoteCordinates`, data);
};

export const deleteNote = (id: any) => {
  return energyApi.get(`/Unity/DeleteNote` + `?id=${id}`);
};

// Bubbles

export const createBubble = (data: any) => {
  return energyApi.post(`/Unity/CreateBubble`, data);
};

export const updateBubble = (data: any) => {
  return energyApi.post(`/Unity/UpdateBubble`, data);
};

export const deleteBubble = (id: any) => {
  return energyApi.get(`/Unity/DeleteBubble` + `?id=${id}`);
};


export const getLabelsMeta = () => {
  return energyApi.get(`/Unity/GetUnityLabelMeta`);
};

export const getLabel = (id: any) => {
  return energyApi.get(`Unity/GetLabel?id=${id}`);
};

export const createLabel = (data: any) => {
  return energyApi.post(`/Unity/CreateLabel`, data);
};

export const updateLabel = (data: any) => {
  return energyApi.post(`/Unity/UpdateLabel`, data);
};

export const deleteLabel = (id: any) => {
  return energyApi.get(`/Unity/DeleteLabel` + `?id=${id}`);
};

export const updateLabelPos = (data: any) => {
  return energyApi.post(`/Unity/UpdateLabelCordinates`, data);
};

export const updateScene = (data: any) => {
  return energyApi.post(`/Unity/UpdateScene`, data);
};

export const getScene = () => {
  return energyApi.get(`/Unity/GetScene`);
};